import React from "react";
import { 
  Toolbar, 
  Typography, 
  Button, 
  Box, 
  IconButton, 
  Stack, 
  useScrollTrigger,
  alpha 
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar } from "../Helper/DashboardNavHelper";
import { Circle } from "@mui/icons-material";
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import DarkModeToggle from "./Switch/DarkModeToggle";

const DashboardNavbar = ({ userEmail, onLogout, navState, openNav }) => {
  // 1. Detect if the user has scrolled more than 10px from the top
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 10,
  });

  return (
    <AppBar 
      position="fixed" 
      open={navState} 
      
      sx={{ 
        // 1. Remove shadow when transparent, keep it when solid
        boxShadow: trigger ? 'none' : 4, 
        transition: 'all 0.3s ease-in-out',
        borderRadius: 0,

        // 2. Logic Inversion:
        // If NOT triggered (at top): Solid Primary Color
        // If triggered (scrolling): Translucent/Transparent
        backgroundColor: (theme) => 
            trigger 
            ? alpha(theme.palette.background.default, 0.7) // Translucent on scroll
            : theme.palette.primary.main,                  // Solid at top

        // 3. Apply blur only when scrolling for the glass effect
        backdropFilter: trigger ? 'blur(10px)' : 'none', 

        // 4. Contrast text color: White on solid primary, theme text on transparent
        color: (theme) => 
            trigger 
            ? theme.palette.text.primary 
            : theme.palette.primary.contrastText,
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          onClick={() => openNav(true)}
          edge="start"
          sx={{ marginRight: 1, ...(navState && { display: 'none' }) }}
        >
          <MenuIcon />
        </IconButton>

        <Stack sx={{ flexGrow: 1 }} direction={'row'} spacing={1} alignItems="center">
          <SchoolOutlinedIcon />
          <Typography fontWeight={"bold"} variant="h5" component="div">
          UnifyEdu
          </Typography>
        </Stack>

        {userEmail && (
          <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
             <Typography variant="caption" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Circle sx={{ fontSize: 8, color: trigger ? 'success.main' : '#9dff9d' }} /> 
                {userEmail}
              </Typography>
          </Box>
        )}

        <Stack direction="row" spacing={1} alignItems="center">
          <DarkModeToggle />        
          <Button 
            variant={trigger ? "outlined" : "contained"} 
            disableElevation
            color={trigger ? "primary" : "inherit"}
            onClick={onLogout}
            sx={{ 
                // Adjusting button contrast for the solid primary background
                ...( !trigger && { 
                    bgcolor: alpha('#fff', 0.1), 
                    '&:hover': { bgcolor: alpha('#fff', 0.2) } 
                })
            }}
          >
            Logout
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;